/**
 * Language Dropdown - KISS version with Tailwind
 * Works on Desktop (hover) and iPad/Mobile (click)
 */
document.addEventListener('DOMContentLoaded', function () {
	const container = document.querySelector('.lang-nav')
	const menu = container?.querySelector('.lang-menu')
	const button = container?.querySelector('.lang-btn')

	if (!container || !menu || !button) return

	// Initial: Entferne 'hidden' damit CSS-Transitions funktionieren, aber Menu bleibt invisible
	menu.classList.remove('hidden')

	// Simple position update
	function setMenuPosition() {
		const rect = button.getBoundingClientRect()
		const isMobile = window.innerWidth < 1024

		if (isMobile) {
			// Mobile: OBERHALB - calculate from top
			menu.style.bottom = window.innerHeight - rect.top + 8 + 'px'
			menu.style.top = 'auto'
		} else {
			// Desktop: UNTERHALB
			menu.style.top = rect.bottom + 8 + 'px'
			menu.style.bottom = 'auto'
		}
		menu.style.right = window.innerWidth - rect.right + 'px'
	}

	// Set position on load and resize
	setMenuPosition()
	window.addEventListener('resize', setMenuPosition)

	// Click handler - works on all devices including iPad
	button.addEventListener('click', function (e) {
		e.preventDefault() // Important for iPad
		e.stopPropagation()

		const isOpen = menu.classList.contains('!visible')

		if (isOpen) {
			// Close menu
			menu.classList.remove('!visible', '!opacity-100')
		} else {
			// Open menu
			setMenuPosition() // Update position before showing
			menu.classList.add('!visible', '!opacity-100')
		}
	})

	// Close when clicking outside
	document.addEventListener('click', function (e) {
		if (!container.contains(e.target)) {
			menu.classList.remove('!visible', '!opacity-100')
		}
	})

	// iPad specific: Prevent hover issues
	if ('ontouchstart' in window) {
		container.classList.remove('group') // Remove hover trigger
	}
})
